import ContactRow from './ContactRow'

const ContactTable = ({ data }) => {
  console.log(data)
  return (
    <div className="w-full ">
      <div className="flex py-2  text-darkBlue sticky top-0 bg-lightBlue/10 z-10">
        <div className="flex-1 p-2 items-center justify-center flex">
          From Id
        </div>
        <div className="flex-1 p-2 items-center  flex">Full Nmae</div>
        <div className="flex-1 p-2 items-center justify-center flex">Email</div>
        <div className="flex-1 p-2 items-center justify-center flex">
          Message
        </div>
        <div className="flex-1 p-2 items-center justify-center flex">
          creation Date
        </div>
        <div className="flex-1 p-2 items-center justify-center flex">
          Actions
        </div>
      </div>
      <div className="overflow-y-auto max-h-96">
        {data?.map((row, index) => (
          <ContactRow key={index} index={index} row={row} />
        ))}
      </div>
    </div>
  )
}

export default ContactTable
